import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Clock(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 120 120">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.333 60c0 29.455-23.878 53.333-53.333 53.333S6.667 89.455 6.667 60 30.545 6.667 60 6.667 113.333 30.545 113.333 60zM60 10c27.614 0 50 22.386 50 50s-22.386 50-50 50-50-22.386-50-50c.03-27.602 22.398-49.97 50-50zm0 18.33c.818 0 1.499.59 1.64 1.368l.027.3V59.31l19.537 19.518c.58.579.644 1.477.194 2.126l-.192.232a1.667 1.667 0 01-2.127.193l-.23-.192-20.027-20.008a1.667 1.667 0 01-.468-.916l-.02-.263V29.997c0-.92.746-1.666 1.666-1.666z"
      ></path>
    </IconSvg>
  );
}
